import { Component } from '@angular/core'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatMenuModule } from '@angular/material/menu'

@Component({
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
  ],
  selector: 'sans-shared-hamburger-menu',
  templateUrl: './shared-hamburger-menu.component.html',
  styleUrls: ['./shared-hamburger-menu.component.scss'],
})
export class SharedHamburgerMenuComponent {
  public hamburgerMenuAriaLabel = $localize`:Aria label|HamburgerMenuComponent:Hamburger menu`
}
